import request from "@/utils/request";

/**
 * 知识库 AI 对话
 * @param {Array<{role: string, content: string}>} messages - 完整的多轮对话历史
 * @param {string} sessionId - 当前会话 id,通过请求头 X-Hermes-Session-Id 透传给后端
 */
export function chatWithKnowledge(messages, sessionId) {
  return request({
    url: "/zhgl/ai/chat",
    method: "post",
    headers: sessionId ? { "X-Hermes-Session-Id": sessionId } : {},
    data: {
      model: "hermes-agent",
      messages,
      temperature: 0.7,
      stream: false
    }
  });
}
